import type { ReactNode } from 'react'

import cx from 'classnames'
import { useSlate } from 'slate-react'

import { isBlockTypeActive, toggleBlock } from '../../util'

interface Props {
  label: string
  format: string
  icon: ReactNode | string
}

export function BlockButtonInSelect ({ label, format, icon }: Props): JSX.Element {
  const editor = useSlate()
  const isActive = isBlockTypeActive(editor, format)

  return (

    <button
      type='button'
      className={cx('py-3 px-2 rounded-sm transition-colors flex flex-row gap-3 w-full hover:bg-gray-100', {
        'text-primary [&_span]:text-primary': isActive
      })}
      onMouseDown={event => {
        event.preventDefault()
        toggleBlock(editor, format)
      }}
      title={label}
    >
      {typeof icon === 'string'
        ? (
          <i className={`fa fa-${icon} fa-fw`} />
        )
        : icon }
      <span className='break-keep'>{label}</span>
    </button>
  )
}
